import React from "react";
import { useTabIndicator } from "../../components/useTabIndicator";
import { useLocation, useNavigate } from "react-router-dom";
import AuthContext from "../../context/AuthContext";
import { useContextSelector } from "use-context-selector";

const BottomNavigation = () => {
  const location = useLocation();
  let loc = location?.pathname?.split("/")[1];
  const { containerRef, setActiveIndex, indicatorStyle } = useTabIndicator(
    loc == "league-velki" ? 2 : 1
  );
  const navigate = useNavigate();

  const setShowBets = useContextSelector(AuthContext, (ctx) => {
    return ctx.setShowBets;
  });
  return (
    <div
      data-v-649ce69d
      className="fixed left-0 bottom-0 w-full z-30"
      style={{
        "--54b41d2b": `${indicatorStyle?.width || 68}px`,
        "--3f1e2085": `translateX(${indicatorStyle?.x || 115}px)`,
      }}
    >
      <div
        ref={containerRef}
        data-v-649ce69d
        className="relative container mx-auto h-60px flex items-center justify-around bg-white border-t border-black-300"
      >
        {menuItems.map((item, index) => (
          <div
            onClick={() => {
              if (item?.navigate == "bet") {
                setShowBets(true);
              } else {
                if (["Sports", "Leagues"].includes(item?.label)) {
                  navigate(item?.navigate);
                } else {
                  window.location.replace(item?.navigate);
                }
              }
            }}
            data-v-649ce69d
            key={index}
            className="relative z-10 flex flex-col justify-center items-center cursor-pointer rounded-lg w-60px"
            data-is-leagues={item.isLeagues}
            data-is-multibet={item.isMultibet}
          >
            <i
              data-v-649ce69d
              className={`text-20 relative flex items-center justify-center pb-1 pt-6px ${item.icon
                } ${item.active ? "text-menu-active-icon" : "text-black-900"}`}
            />
            <p
              data-v-649ce69d
              className={`pb-2 text-11 ${item.active ? "text-menu-active-icon" : "text-black-900"
                }`}
            >
              {item.label}
            </p>
          </div>
        ))}
        <div
          data-v-649ce69d
          className="tab-indicator absolute left-0 top-6px z-0 rounded-lg bg-primary"
        />
      </div>
    </div>
  );
};

export default BottomNavigation;

const menuItems = [
  {
    label: "Main Home",
    icon: "icon-home",
    active: false,
    isLeagues: false,
    isMultibet: false,
    navigate: "/",
  },
  // {
  //   label: "Casino",
  //   icon: "icon-poker",
  //   active: false,
  //   isLeagues: false,
  //   isMultibet: false,
  //   navigate: "/live-casino",
  // },
  {
    label: "Sports",
    icon: "icon-sport",
    active: true,
    isLeagues: false,
    isMultibet: false,
    navigate: "/sports-velki",
  },
  {
    label: "Leagues",
    icon: "icon-trophy",
    active: false,
    isLeagues: true,
    isMultibet: false,
    navigate: "/league-velki",
  },
  {
    label: "My Bets",
    icon: "icon-list",
    active: false,
    isLeagues: false,
    isMultibet: false,
    navigate: "bet",
  },
];
